export const mapKidRowToModel = (row) => ({
  susId: row.susId,
  fullName: `${row.lastName} ${row.firstName}`,
  firstName: row.firstName,
  lastName: row.lastName,
  gender: getGender(row.gender),
  address: getAddress(row),
  birthday: row.birthday,
  teacherName: row.teacherName,
  schoolBus: getBooleanValue(row.schoolBus),
  motherLanguage: row.motherLanguage,
  previousExperience: getBooleanValue(row.previousExperience),
  entranceOrdinary: getBooleanValue(row.entranceOrdinary),
  germanLanguageLevel: getGermanLanguageLevel(row.germanLanguageLevel),
  note: row.note,
  specialNote: row.specialNote,
});

export const mapStudentRowToModel = (row) => ({
  fullName: `${row.lastName} ${row.firstName}`,
  firstName: row.firstName,
  lastName: row.lastName,
  gender: getGender(row.gender),
  address: getAddress(row),
  teacherName: row.teacherName,
  teacher: row.teacher,
  bestFriendName: row.bestFriendName,
  knowledgeLevel: getKnowledgeLevel(row),
  knowledgeLevelNote: row.knowledgeLevelNote,
  knowledgeLevelSpecialNote: row.knowledgeLevelSpecialNote,
  inS: row.inS ? getBooleanValue(row.inS) : undefined,
  specialNeeds: getSpecialNeeds(row),
  specialNeedsNote: row.specialNeedsNote,
  germanLanguageLevel: getGermanLanguageLevelForStudent(row.germanLanguageLevel),
  helpWithStudy: getHelpWithStudy(row),
  note: row.note,
  specialNote: row.specialNote,
});

const getGender = (gender = "") =>
  gender.toLowerCase() === "männlich" ? "male" : "female";

const getBooleanValue = (value = "") =>
  value.toLowerCase() === "ja" ? true : false;

export const getGermanLanguageLevel = (level = '') => {
  switch (level.toLowerCase()) {
    case 'gar kein':
      return 'none';
    case 'wenig':
      return 'little';
    case 'mittel':
      return 'medium';
    case 'viel':
      return 'high';
    case 'ausschliesslich':
      return 'fluent';

    default:
      return level;
  }
};

const getGermanLanguageLevelForStudent = (level = "") => {
  switch (level.toLowerCase()) {
    case "übersetzung notwendig":
      return "little";
    case "genügend bis gut":
      return "high";

    default:
      return '';
  }
};

const getKnowledgeLevel = (row) => {
  if (!row.knowledgeLevel) return undefined;

  const knowledgeLevel = row.knowledgeLevel;

  switch (knowledgeLevel.toLowerCase()) {
    case "teilweise erfüllt":
      return "basic";
    case "erfüllt":
      return "intermediate";
    case "teilweise übertroffen":
      return "advanced";

    default:
      return knowledgeLevel;
  }
};

const getSpecialNeeds = (row) => {
  if (!row.specialNeeds) return undefined;

  const specialNeeds = row.specialNeeds;

  const arr: any[] = [];
  if (specialNeeds.split(", ").length) {
    specialNeeds.split(", ").forEach(e => {
      switch (e.toLowerCase()) {
        case "daz":
          arr.push("germanassecondlanguage");
          return arr
        case "logopadie":
          arr.push("logopedic");
          return arr
        case "logopädie":
          arr.push("logopedic");
          return arr
        case "psychomotorik":
          arr.push("psychomotor");
          return arr

        default:
          return arr;
      }
    });
  }

  return arr
}

const getHelpWithStudy = (row) => {
  if (!row.helpWithStudy) return undefined;

  const helpWithStudy = row.helpWithStudy;

  const arr: any[] = [];
  if (helpWithStudy.split(", ").length) {
    helpWithStudy.split(", ").forEach(e => {
      switch (e.toLowerCase()) {
        case "deutsch":
          arr.push("german");
          return arr
        case "mathe":
          arr.push("maths");
          return arr
        case "lza deutsch":
          arr.push("lzaGerman");
          return arr
        case "lza mathe":
          arr.push("lzaMaths");
          return arr
        default:
          return arr;
      }
    })
  }
  return arr
};

const getAddress = (row) => {
  let address = "";

  if (row.address) {
    address += row.address + "\n";
  }

  if (row.postalCode) {
    address += " ";
    address += row.postalCode;
  }

  if (row.city) {
    address += " ";
    address += row.city;
  }

  return address;
};
